import _createForOfIteratorHelper from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import r from "../managers/braze-instance.js";
import { keys as C } from "../util/code-utils.js";
import { logger as E, IndexedDBAdapter as et } from "../../shared-lib/index.js";
import { BRAZE_MUST_BE_INITIALIZED_ERROR as w } from "../common/constants.js";
export function wipeData() {
  var o = r.p();
  if (null == o) return void E.warn(w);
  o.clearData();
  var t = C(et.Us);
  for (var _o = 0; _o < t.length; _o++) {
    var _n = t[_o],
      _r = et.Us[_n];
    new et(_r, E).clearData();
  }
  if (r.rr()) {
    var _iterator = _createForOfIteratorHelper(r.lr()),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _o2 = _step.value;
        _o2.clearData(!0);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  var n = r.m();
  n && n.fo();
}